import { withDependencies } from '@wix/thunderbolt-ioc'
import { LayoutDoneServiceSymbol, ILayoutDoneService } from '@wix/thunderbolt-symbols'
import { IModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import type { LayoutUpdateHandler } from './types'
import { name } from './symbols'
import { Component } from 'thunderbolt-viewer-manager-types'
import _ from 'lodash'
import { INavigationManager, NavigationManagerSymbol } from 'feature-navigation-manager'
import { MeasureMapApiSymbol } from 'ds-feature-viewer-manager-layout-api'

const layoutProperties = ['height', 'width', 'x', 'y', 'rotationInDegrees', 'fixedPosition', 'scale', 'docked']

export const OnLayoutUpdateHandler = withDependencies(
	[LayoutDoneServiceSymbol, NavigationManagerSymbol, MeasureMapApiSymbol],
	(
		layoutDoneService: ILayoutDoneService,
		navigationManager: INavigationManager,
		measureMapApi
	): IModelUpdatesHandlersImplementor<LayoutUpdateHandler> => {
		const components = new Map<string, Component['layout']>()
		const masterPageComponents = new Map<string, Component['layout']>()

		navigationManager.registerToNavigationStart(() => {
			components.clear()
		})

		const updateComponentLayout = (compId: string, layout: Component['layout'], pageId: string) => {
			pageId === 'masterPage' ? masterPageComponents.set(compId, layout) : components.set(compId, layout)
		}

		return {
			featureName: name,
			handlers: {
				onLayoutUpdate: ({ compId, layout, pageId }) => {
					const prevCompLayout = components.get(compId) || masterPageComponents.get(compId)
					// side effect is also triggered for added components (updateStructure). we want to listen only to changed components
					layout = layout && _.pick(layout, layoutProperties)
					if (prevCompLayout && layout) {
						if (!_.isEqual(prevCompLayout, layout)) {
							updateComponentLayout(compId, layout, pageId)
							// force measure on layout changes to update DM with correct measures,
							// for a case when a new layout didn't change measures in DOM like update height for wRichText (height auto) where layout height less than content height is ignored
							// example: Jira TB-5958
							layoutDoneService.addToChangedComponents(compId)
						}
					} else {
						// added component
						updateComponentLayout(compId, layout, pageId)
					}
					measureMapApi.clearCache()
				},
			},
		}
	}
)
